<template>
  <div class="images-number-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Number of images' | trans }}</div>
      <strong class="badge badge-starter d-flex align-items-center" @click="handleProOrChange"  v-if="projectName === 'Img2Go'">{{ 'STARTER' | trans }}</strong>
      <strong class="badge badge-warning d-flex align-items-center" @click="handleProOrChange"  v-if="projectName !== 'Img2Go'">{{ 'PREMIUM' | trans }}</strong>
    </div>

    <div class="images-number-container">
      <div v-for="obj in numberOfImages" 
        :class="{ 'active': isActive(obj.number), 'disabled': (isFreeUser && obj.number > 2) && !isActive(obj.number) }"
        class="images-number-btn"
        @click="handleProOrChange(obj.number)"
      >
        <strong>{{ obj.number }}</strong>
        <div 
          :class="{ 'active': isActive(obj.number), 'disabled': isFreeUser && !isActive(obj.number) }" 
          class="checkmark-box"
        >
          <i class="fa fa-check"></i>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import ImagesManager from "../../manager/ImagesManager";
import user from './../../mixins/user.mixin';
import { EventBus } from '../../events/event.bus';
import { EVENT_PAYMENT_UNLOCK_STARTER, EVENT_PAYMENT_UNLOCK_PRO } from "../../events/payment.events";

export default {
  name: "NumberOfImages",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {
      numberOfImages: []
    };
  },
  mounted: function () {

  },
  created: function () {
    this.numberOfImages = ImagesManager.numberOfImages;
  },
  methods: {
    handleProOrChange(number) {
      if (this.isFreeUser && number > 2) {
        if (this.projectName === 'Img2Go') {
          EventBus.$emit(EVENT_PAYMENT_UNLOCK_STARTER, {});
        } else {
          EventBus.$emit(EVENT_PAYMENT_UNLOCK_PRO, {});
        }

      } else {
        const { batch_size, batch_count } = ImagesManager.getByNumber(number);

        this.creatorStudio.settings.conversion.options.batch_size = batch_size;
        this.creatorStudio.settings.conversion.options.batch_count = batch_count;
      }
    },
    isActive(number) {
      return this.currentNumberOfImages === number;
    }
  },
  computed: {
    currentNumberOfImages() {
      const { batch_size , batch_count } = this.creatorStudio.settings.conversion.options;
      
      return ImagesManager.getByBatchSizeAndCount(batch_size, batch_count).number;
    }
  }
};
</script>
<style lang="scss">
.badge-warning {
  cursor: pointer;
}

.images-number-box {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.checkmark-box {
  color: white;
  background: #1266F1;
  border-radius: 50%;
  position: absolute;
  padding: 5px;
  width: 24px;
  height: 24px;
  right: -10px;
  top: -13px;
  justify-content: center;
  align-items: center;
  display: none;

  &.active {
    display: flex !important;
  }
}

.images-number-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.badge-starter {
  background: #7759c2;
}

.images-number-btn {
  cursor: pointer;
  width: 50px;
  height: 45px;
  padding: 3px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: relative;
  border-radius: 9px;
  background: #383838;

  &.active {
    border: 3px solid #1266F1;
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:hover {
    background: #323232;
  }
}
</style>